/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-04 20:14:17
 * @LastEditTime: 2020-08-17 10:45:31
 * @Description: 母液配方store
 */
import {
    getRecipeSemis,
    getRecipeSemisById,
    createRecipeSemi,
    updateRecipeSemi
} from '@/api/recipeSemi'
import {
    getMaterials
} from '@/api/material'
import Vue from 'vue'

const state = {
    recipeSemiList: [],
    materialList: []
}

const getters = {

}

const actions = {
    async getMaterialListAction({
        commit
    }, payload) {
        try {
            const res = await getMaterials(payload);
            commit('SETMATERIALLIST', res.data.materialList)
        } catch (error) {
            throw error.message
        }
    },

    async getRecipeSemisAction({
        commit
    }, payload) {
        try {
            const recipeSemis = await getRecipeSemis(payload)
            commit('SETRECIPESEMIS', recipeSemis.data)
            return recipeSemis.data
        } catch (error) {
            throw error.message
        }

    },
    async getRecipeSemisByIdAction({
        commit
    }, id) {
        try {
            const recipeSemis = await getRecipeSemisById(id)
            recipeSemis.data.detail = recipeSemis.data.detail.map((e) => {
                return {
                    "_id": e.material._id,
                    "name": e.material.name,
                    "ratio": e.ratio
                }
            })
            return recipeSemis.data
        } catch (error) {
            throw error.message
        }

    },
    async createRecipeSemiAction({
        commit
    }, payload) {
        try {
            const newRecipe = await createRecipeSemi(payload)
            return newRecipe.data
        } catch (error) {
            throw error.message
        }
    },
    async updateRecipeSemiAction({
        commit
    }, payload) {
        try {
            const newRecipeSemi = await updateRecipeSemi(payload.id, payload.data)
            commit("UPDATE_RECIPESEMI", newRecipeSemi.data)
            return newRecipeSemi.data
        } catch (error) {
            throw error.message
        }
    },
}

const mutations = {
    SETRECIPESEMIS(state, recipeSemis) {
        state.recipeSemiList = recipeSemis.recipe
    },

    SETMATERIALLIST(state, materialList) {
        state.materialList = materialList
    },
    UPDATE_RECIPESEMI(state, recipeSemi) {
        Vue.set(state.recipeSemiList, state.recipeSemiList.findIndex(x => x._id === recipeSemi._id), recipeSemi)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}